/**
 * holds filters tree
 */
export class FiltersService {
  constructor(
    $q,
    FilterResource,
    globalAlert,
  ) {
    this.$q = $q;
    this.FilterResource = FilterResource;
    this.globalAlert = globalAlert;
    this.filters = [];
    this.loading = false;
  }

  load() {
    return this.$q.resolve()
      .then(() => {
        this.loading = true;
        return this.FilterResource.list();
      })
      .then(filters => {
        this.filters = filters;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  save(filter) {
    return this.FilterResource.save(filter)
      .then(({status, data, error}) => {
        if (error) {
          this.globalAlert(error.message);
          return;
        }
        let originalFilter = this.findById(filter.id);
        Object.assign(originalFilter, data);
        Object.assign(filter, data);
        filter._changed = false;
      });
  }

  find(predicate) {
    for (let i = 0; i < this.filters.length; ++i) {
      const filter = this.filters[i];
      let f = filter.find(predicate);
      if (f) {
        return f;
      }
    }
  }

  findById(id) {
    return this.find(f => f.id === id);
  }

  getPath(filter) {
    for (let i = 0; i < this.filters.length; ++i) {
      const f = this.filters[i];
      let path = f.getPath(filter);
      if (path) {
        return path;
      }
    }
    return [];
  }

  getCardFilter(dim) {
    return this.find(filter =>
      filter.isDimensionCard && filter.dimension === dim) ||
      this.getDefaultCardFilter(dim);
  }

  getDefaultCardFilter(dim) {
    dim = dim.split('@')[0];
    return this.find(filter =>
      filter.isDimensionCard && filter.dimension.startsWith(dim));
  }

  onDeleteFilter(filter) {
    const path = this.getPath(filter);
    if (path.length) {
      path.pop().removeChild(filter);
    } else {
      this.filters = this.filters.filter((f) => f.id != filter.id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/filters.service.js